module.exports = __webpack_public_path__ + "img/hashtaggy-5.a8aad2dc.jpg";